(function () {
	'use strict';

	var root = document.querySelector('[data-holiday-2026]');
	if (!root) {
		return;
	}

	var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	var hero = root.querySelector('.holiday-2026-hero');

	window.setTimeout(function () {
		hero.classList.add('is-in');
	}, reduceMotion ? 0 : 300);

	var quiz = root.querySelector('.holiday-2026-quiz');
	var quizStart = root.querySelector('.holiday-2026-quiz__start');
	var quizContent = root.querySelector('.holiday-2026-quiz__slot');

	if (quiz && quizStart && quizContent) {
		quizStart.addEventListener('click', function () {
			quizStart.setAttribute('aria-expanded', 'true');
			quizContent.hidden = false;
			quiz.classList.add('is-open');

			window.requestAnimationFrame(function () {
				quizContent.focus({ preventScroll: true });
				var quizTop = quiz.querySelector('.holiday-2026-quiz__card').getBoundingClientRect().top + window.pageYOffset - 120;
				window.scrollTo({
					top: quizTop,
					behavior: reduceMotion ? 'auto' : 'smooth'
				});
			});
		});
	}

	var bars = Array.prototype.slice.call(root.querySelectorAll('.holiday-2026-bar'));
	var dish = root.querySelector('.holiday-2026-plate__dish');
	var plateStarted = false;

	function resetBars() {
		bars.forEach(function (bar) {
			bar.classList.remove('is-clear');
			bar.style.setProperty('--holiday-2026-x', (Math.random() * 60 - 30) + 'px');
			bar.style.setProperty('--holiday-2026-rotation', (Math.random() * 30 - 15) + 'deg');
			bar.classList.add('is-off');
		});
	}

	function animatePlate() {
		resetBars();
		void dish.offsetWidth;
		var index = 0;

		function addNextBar() {
			if (index < bars.length) {
				bars[index].classList.remove('is-off');
				index += 1;
				window.setTimeout(addNextBar, 420);
				return;
			}

			window.setTimeout(function () {
				bars.forEach(function (bar) {
					bar.classList.add('is-clear');
				});
				window.setTimeout(animatePlate, 900);
			}, 4500);
		}

		addNextBar();
	}

	if (!reduceMotion && bars.length && dish) {
		resetBars();

		if ('IntersectionObserver' in window) {
			var plateObserver = new IntersectionObserver(function (entries) {
				if (entries[0].isIntersecting && !plateStarted) {
					plateStarted = true;
					window.setTimeout(animatePlate, 500);
					plateObserver.disconnect();
				}
			}, { threshold: .35 });

			plateObserver.observe(dish);
		} else {
			animatePlate();
		}
	}

	var ctaPattern = root.querySelector('.holiday-2026-cta__pattern');
	if (ctaPattern) {
		var svgNamespace = 'http://www.w3.org/2000/svg';
		var petal = 'M0,-1 L0.16,-0.6 L0,-0.22 L-0.16,-0.6Z';
		var petals = '';
		var angle;

		for (angle = 0; angle < 6; angle += 1) {
			petals += '<path d="' + petal + '" transform="rotate(' + (angle * 60) + ')"></path>';
		}

		var stepX = 150;
		var stepY = 130;
		var fragment = document.createDocumentFragment();
		var row;
		var column;

		for (row = -1; row < 6; row += 1) {
			for (column = -1; column < 18; column += 1) {
				var flakeSize = (row + column) % 3 === 0 ? 78 : ((row * 7 + column) % 2 ? 56 : 40);
				var svg = document.createElementNS(svgNamespace, 'svg');
				svg.setAttribute('viewBox', '-1 -1 2 2');
				svg.setAttribute('width', flakeSize);
				svg.setAttribute('height', flakeSize);
				svg.innerHTML = '<g fill="#ED3029">' + petals + '</g>';
				svg.style.left = (column * stepX + (row % 2 ? stepX / 2 : 0) - flakeSize / 2) + 'px';
				svg.style.top = (row * stepY - flakeSize / 2) + 'px';
				svg.style.setProperty('--holiday-2026-spin-duration', (10 + ((row * 5 + column * 3) % 7) * 2) + 's');
				svg.style.setProperty('--holiday-2026-spin-direction', (row + column) % 2 ? 'reverse' : 'normal');
				fragment.appendChild(svg);
			}
		}

		ctaPattern.appendChild(fragment);
		ctaPattern.classList.add('is-flakes');
	}
}());
